import { axios } from "../../api";
import router from "../../router";

export default {
    state: {
        customerData: {},
        customerId: {},
        items: [],
        menu: [],
        cart: [],
        getPaymentMethod: [],
        paymentMethod: [],
        checkout: {},

        // payment approve
        nominalPayment: {},
        approve: {},
    },
    getters: {
        customerData: (state) => state.customerData,
        items: (state) => state.items,
        cart: (state) => state.cart,
        paymentMethod: (state) => state.paymentMethod,
        checkout: (state) => state.checkout,
        customerId: (state) => state.customerId,

        // payment approve
        nominalPayment: (state) => state.nominalPayment,
    },
    actions: {
        ADD_CUSTOMER_DATA({ commit }, value) {
            commit("ADD_CUSTOMER_DATA", value);
        },
        GET_ITEMS({ commit }) {
            axios
                .get("/getMenu")
                .then((res) => {
                    commit("GET_ITEMS", res.data);
                })
                .catch((err) => console.log(err));
        },
        ADD_TO_CART({ commit }, item) {
            commit("ADD_TO_CART", item);
        },
        ADD_QUANTITY({ commit }, id) {
            commit("ADD_QUANTITY", id);
        },
        REDUCE_QUANTITY({ commit }, id) {
            commit("REDUCE_QUANTITY", id);
        },
        FILTER_ITEMS({ commit }, categories) {
            commit("FILTER_ITEMS", categories);
        },
        GET_PAYMENT_METHOD({ commit }) {
            axios
                .get("/getTypePaymentMethod")
                .then((res) => {
                    commit("GET_PAYMENT_METHOD", res.data);
                })
                .catch((err) => console.log(err));
        },
        SELECT_PAYMENT_METHOD({ commit }, id) {
            commit("SELECT_PAYMENT_METHOD", id);
        },
        ADD_CHECKOUT({ commit }, paymentMethod) {
            commit("ADD_CHECKOUT", paymentMethod);
        },

        // payment approve
        NOMINAL_PAYMENT({ commit }, payload) {
            commit("NOMINAL_PAYMENT", payload);
        },
        APPROVED_BY_BANK_TRANSFER({ commit }, payload) {
            commit("APPROVED_BY_BANK_TRANSFER", payload);
        },
        APPROVED_BY_CASH({ commit }, payload) {
            commit("APPROVED_BY_CASH", payload);
        },
    },
    mutations: {
        ADD_CUSTOMER_DATA(state, payload) {
            state.customerData = payload;

            // console.log(state.customerData);
            router.push("/newmenu");
        },
        GET_ITEMS(state, item) {
            state.menu = item;
        },
        ADD_TO_CART(state, item) {
            state.cart.push({
                ...item,
                quantity: 1,
                isActive: false,
                notesBody: "",
                totalItemDiscount: (item.price * item.menu_discount) / 100,
            });
        },
        ADD_QUANTITY(state, id) {
            const currentItem = state.cart.find((product) => product.id === id);
            currentItem.totalItemDiscount =
                (currentItem.totalItemDiscount / currentItem.quantity) * (currentItem.quantity + 1);
            currentItem.quantity++;
        },
        REDUCE_QUANTITY(state, id) {
            const currentItem = state.cart.find((product) => product.id === id);
            currentItem.totalItemDiscount =
                (currentItem.totalItemDiscount / currentItem.quantity) * (currentItem.quantity - 1);
            if (currentItem.quantity > 1) {
                currentItem.quantity--;
            } else {
                state.cart = state.cart.filter((product) => product.id !== id);
            }
        },
        FILTER_ITEMS(state, categories) {
            if (categories == "All") {
                state.items = state.menu;
            } else {
                state.items = state.menu.filter((item) => item.category_id == categories);
            }
        },
        GET_PAYMENT_METHOD(state, payload) { 
            state.getPaymentMethod = payload;
        },
        SELECT_PAYMENT_METHOD(state, id) {
            state.paymentMethod = state.getPaymentMethod.filter((method) => method.id == id);
        },
        async ADD_CHECKOUT(state) {
            const currentPrice = state.cart.reduce(
                (a, b) => a + b.quantity * b.price - (b.price * b.quantity * b.menu_discount) / 100,
                0
            );
            const totalDiscount = state.cart.reduce(
                (a, b) => a + (b.price * b.quantity * b.menu_discount) / 100,
                0
            );
            const currentHpp = state.cart.reduce((a, b) => a + b.quantity * b.hpp, 0);
            const paymentFee = state.paymentMethod[0].transaction_fee;

            const totalPrice = currentPrice + paymentFee;
            const paymentMethodName = state.paymentMethod[0].name;
            const tableId = state.customerData.table_id

            state.checkout = {
                cart: state.cart,
                customerData: state.customerData,
                totalDiscount: totalDiscount,
                totalPrice: totalPrice,
                totalHpp: currentHpp,
                paymentMethodName: paymentMethodName,
                paymentFee: paymentFee,
                tableId : tableId
            };

            await axios
                .post("/postData", state.checkout)
                .then((res) => {
                    state.cart = []
                    res
                    router.push("/");
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        // payment approve
        NOMINAL_PAYMENT(state, payload) {
            state.nominalPayment = payload;
            // console.log(state.nominalPayment);
        },
        async APPROVED_BY_BANK_TRANSFER(state, payload) {
            const status = "order processing";

            state.approve = {
                id: payload.id,
                approved_by: payload.personSelected,
                status: status,
            };

            await axios
                .post("/approvedBy", state.approve)
                .then(() => {
                    router.push("/");
                })
                .catch((err) => {
                    console.log(err);
                });

            // console.log(state.approve);
        },
        async APPROVED_BY_CASH(state, payload) {
            const status = "order processing";
            const nominalPayment = state.nominalPayment.nominal;

            state.approve = {
                id: payload.id,
                approved_by: payload.personSelected,
                status: status,
                total_received: nominalPayment,
                change: payload.change,
            };

            await axios
                .post("/orderCash", state.approve)
                .then(() => {
                    router.push("/");
                })
                .catch((err) => {
                    console.log(err);
                });

            // console.log(state.approve);
        },
    },
};
